import React from "react";
import "./whatsapp.css";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/+917408452828?text=Hello%2C%20I%20want%20to%20inquire%20about%20your%20books"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <img
        src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
        alt="WhatsApp"
      />
    </a>
  );
};

export default WhatsAppButton;
